
//
const joinPageHeroElement = document.querySelector('.join-page-hero');
const joinPageHeroContentElement = document.querySelector('.join-page-hero-content');
const joinPageHeroPromotionElement = document.querySelector('.join-page-promotion-runner');

//
if (joinPageHeroElement !== null && joinPageHeroContentElement !== null) {
    const observer = new ResizeObserver(function(entries) {
        requestAnimationFrame(async () => {
            joinPageHeroElement.style.setProperty('--computed-height', joinPageHeroContentElement.offsetHeight + ((joinPageHeroPromotionElement !== null) ? joinPageHeroPromotionElement.offsetHeight : 0) + 'px');
        });
    });
    observer.observe(joinPageHeroElement);
}
